import React from 'react';
import PropTypes from 'prop-types';

import { HideBodyOverflow } from 'components/misc/globalStyles';
import StyledOverlay from './styles';

const Overlay = (props) => {
    const { children, className = '', ...restProps } = props;
    const {
        hidden = false,
        hideOverflow = true,
        zIndex = 1005
    } = restProps;
    const overlayClass = `i3x-component-overlay ${className}`;
    const styledProps = { hidden, hideOverflow, zIndex };

    return (
        <StyledOverlay className={overlayClass} {...styledProps}>
            {hideOverflow && <HideBodyOverflow />}
            {children}
        </StyledOverlay>
    );
};

Overlay.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    hidden: PropTypes.bool,
    hideOverflow: PropTypes.bool,
};

export default Overlay;
